import React from 'react'
import PropTypes from 'prop-types'
import { observer } from 'mobx-react'
import useField from '../hooks/use-field'

function File (props) {
  const field = useField(props)

  return field.wrap((fieldProps) => (
    <div className='file-field'>
      <input
        id={field.id}
        name={field.name}
        type='file'
        onBlur={field.onBlur}
        onFocus={field.onFocus}
        onChange={e => field.onChange(e.target.value)}
        {...fieldProps}
        accept={props.accept}
        multiple={props.multiple}
      />
      {(!!field.value && field.value.url) ? (
        <a className='btn arrow-right-link' target='_blank' href={field.value.url}>Se nuværende fil</a>
      ) : null}
      {props.children}
    </div>
  ))
}

File.defaultProps = {
  ...useField.defaultProps,
  accept: null,
  multiple: false
}

File.propTypes = {
  ...useField.propTypes,
  accept: PropTypes.string,
  multiple: PropTypes.bool
}

export default observer(File)
